import { Navigate } from 'react-router-dom';

const KEY = import.meta.env.VITE_TOKEN_STORAGE_KEY || 'auth_token';

export default function AlreadyAuthed({ children }) {
  const token = localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
  return token ? <Navigate to="/dashboard" replace /> : children;
}
